export const Functions = {
  create: true,
  delete: false,
  detail: true,
  search: false
};
export const PageName = '子后台管理';